import { render, staticRenderFns } from "./Worklist.vue?vue&type=template&id=0a7cff0c&scoped=true"
import script from "./Worklist.vue?vue&type=script&lang=js"
export * from "./Worklist.vue?vue&type=script&lang=js"
import style0 from "./Worklist.vue?vue&type=style&index=0&id=0a7cff0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7cff0c",
  null
  
)

export default component.exports